"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateInspectionApprovalResponseDataDto = instanceOfUpdateInspectionApprovalResponseDataDto;
exports.UpdateInspectionApprovalResponseDataDtoFromJSON = UpdateInspectionApprovalResponseDataDtoFromJSON;
exports.UpdateInspectionApprovalResponseDataDtoFromJSONTyped = UpdateInspectionApprovalResponseDataDtoFromJSONTyped;
exports.UpdateInspectionApprovalResponseDataDtoToJSON = UpdateInspectionApprovalResponseDataDtoToJSON;
exports.UpdateInspectionApprovalResponseDataDtoToJSONTyped = UpdateInspectionApprovalResponseDataDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateInspectionApprovalResponseDataDto interface.
 */
function instanceOfUpdateInspectionApprovalResponseDataDto(value) {
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('inspectionId' in value) || value['inspectionId'] === undefined)
        return false;
    if (!('isApproved' in value) || value['isApproved'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function UpdateInspectionApprovalResponseDataDtoFromJSON(json) {
    return UpdateInspectionApprovalResponseDataDtoFromJSONTyped(json, false);
}
function UpdateInspectionApprovalResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'enquiryId': json['enquiryId'],
        'inspectionId': json['inspectionId'],
        'isApproved': json['isApproved'],
        'status': json['status'],
    };
}
function UpdateInspectionApprovalResponseDataDtoToJSON(json) {
    return UpdateInspectionApprovalResponseDataDtoToJSONTyped(json, false);
}
function UpdateInspectionApprovalResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'enquiryId': value['enquiryId'],
        'inspectionId': value['inspectionId'],
        'isApproved': value['isApproved'],
        'status': value['status'],
    };
}
